import { useNavigate } from "react-router-dom";
import {
    UserPlusIcon,
    CalendarDaysIcon,
    CalendarIcon,
    EnvelopeIcon
} from '@heroicons/react/24/outline'
const QuickActions = () => {
    const navigate = useNavigate();
    return (
        <div>
            {/* Grid of 3  */}
            <div className="grid grid-cols-3 gap-4 mt-4">
                {/* Card 1 with widht of 2 in sm: and up*/}
                <div className="bg-white rounded-lg p-6 col-span-3 sm:col-span-2 border">
                    <h3 className="text-xl font-bold">Quick Actions</h3>
                    <div className="grid grid-cols-2 gap-4 mt-4">
                        <div className="hover:bg-gray-100 rounded-lg p-4 border cursor-pointer col-span-2 sm:col-span-1"
                            onClick={() => navigate("/employees/create")}
                        >
                            <UserPlusIcon className="h-6 w-6 text-gray-500 inline mr-3" />
                            <span className="text-gray-900">Add Employee</span>
                        </div>

                        <div className="hover:bg-gray-100 rounded-lg p-4 border cursor-pointer col-span-2 sm:col-span-1"
                            onClick={() => navigate("/attendance/new")}
                        >
                            <CalendarIcon className="h-6 w-6 text-gray-500 inline mr-3" />
                            <span className="text-gray-900">Create New Attendance</span>
                        </div>

                        <div className="hover:bg-gray-100 rounded-lg p-4 border cursor-pointer col-span-2 sm:col-span-1"
                            onClick={() => navigate("/leaves/new")}
                        >
                            <CalendarDaysIcon className="h-6 w-6 text-gray-500 inline mr-3" />
                            <span className="text-gray-900">Create New Leave</span>
                        </div>

                    </div>
                </div>
                <div className="bg-white rounded-lg p-6 col-span-3 sm:col-span-1 border">
                    <h3 className="text-xl font-bold text-blue-800">
                        Need Help? We are here for you!
                    </h3>
                    <div className="hover:bg-gray-100 rounded-lg p-4 border cursor-pointer mt-6"
                        onClick={() => navigate("/support/new")}
                    >
                        <EnvelopeIcon className="h-6 w-6 text-gray-500 inline mr-3" />
                        <span className="text-gray-900">Create A Support Ticket</span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default QuickActions;